import { render } from "./EndSection.vue?vue&type=template&id=201e0e0e&scoped=true"
import script from "./EndSection.vue?vue&type=script&lang=js"
export * from "./EndSection.vue?vue&type=script&lang=js"

import "./EndSection.vue?vue&type=style&index=0&id=201e0e0e&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e0e0e"]])

export default __exports__